import { auditoriaSections } from './auditoriaSections';

export const auditoriaManual = {
  id: 'mod-auditoria',
  title: 'Auditoría de inventario',
  isVisible: (ctx) => ctx.canSeeKardexAudit,
  intro:
    'Reglas, alertas de kardex, tomas de inventario y destinatarios de notificación. Cada función del menú Auditoría documentada con 12 apartados.',
  sections: auditoriaSections,
};
